module.exports = __webpack_public_path__ + "img/ifast-bank.316f43a.svg";